import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "container product-details" };
const _hoisted_2 = { class: "d-md-none col-12" };
const _hoisted_3 = { class: "mb-2 ms-3" };
const _hoisted_4 = { class: "text-muted mr-1" };
const _hoisted_5 = /*#__PURE__*/ _createTextVNode();
const _hoisted_6 = { class: "mb-4 ms-3" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("div", { class: "mb-4" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "seperator" })
], -1);
const _hoisted_8 = { class: "row position-relative flex-row-reverse flex-md-row" };
const _hoisted_9 = { class: "col-md-6 pl-0 pr-4" };
const _hoisted_10 = { class: "sticky-top-20" };
const _hoisted_11 = {
    key: 0,
    class: "image-gallery mt-3",
    style: { "height": "unset" }
};
const _hoisted_12 = {
    key: 0,
    class: "thumbnail d-none d-lg-block"
};
const _hoisted_13 = { style: { "width": "100%" } };
const _hoisted_14 = { class: "border rounded" };
const _hoisted_15 = { class: "p-2 border-bottom bg-light fw-bold" };
const _hoisted_16 = { class: "p-2 pb-0" };
const _hoisted_17 = {
    style: { "display": "flex", "flex-direction": "row" },
    class: "mb-2"
};
const _hoisted_18 = { style: { "flex": "1 1 auto" } };
const _hoisted_19 = { class: "col-md-6 pl-4 product-details" };
const _hoisted_20 = { class: "mb-2 ms-3 d-none d-md-block" };
const _hoisted_21 = { class: "text-muted mr-1" };
const _hoisted_22 = /*#__PURE__*/ _createTextVNode();
const _hoisted_23 = { class: "mb-4 ms-3 d-none d-md-block" };
const _hoisted_24 = /*#__PURE__*/ _createElementVNode("div", { class: "mb-4 d-none d-md-block" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "seperator" })
], -1);
const _hoisted_25 = ["innerHTML"];
const _hoisted_26 = {
    key: 0,
    class: "mb-4"
};
const _hoisted_27 = /*#__PURE__*/ _createElementVNode("div", { class: "seperator" }, null, -1);
const _hoisted_28 = [
    _hoisted_27
];
const _hoisted_29 = /*#__PURE__*/ _createElementVNode("div", { class: "mb-4" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "seperator" })
], -1);
const _hoisted_30 = {
    key: 0,
    class: "mb-3 mt-2"
};
const _hoisted_31 = /*#__PURE__*/ _createElementVNode("div", { class: "seperator" }, null, -1);
const _hoisted_32 = [
    _hoisted_31
];
const _hoisted_33 = {
    key: 3,
    class: "row ms-2 me-2 mb-2"
};
const _hoisted_34 = { class: "col-sm-4" };
const _hoisted_35 = { class: "col-sm-8" };
const _hoisted_36 = {
    key: 0,
    class: "row position-relative mt-4 mb-3"
};
const _hoisted_37 = /*#__PURE__*/ _createElementVNode("div", {
    style: { "border-bottom": "1px dotted rgb(222, 226, 230)" },
    class: "mb-2"
}, [
    /*#__PURE__*/ _createElementVNode("h3", null, "Zubehör")
], -1);
const _hoisted_38 = {
    key: 0,
    class: "col-3 border-end"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_image_viewer = _resolveComponent("g-image-viewer");
    const _component_g_link = _resolveComponent("g-link");
    const _component_g_product_prices = _resolveComponent("g-product-prices");
    const _component_g_product_selector = _resolveComponent("g-product-selector");
    const _component_g_product_configurator = _resolveComponent("g-product-configurator");
    const _component_g_quantity_field = _resolveComponent("g-quantity-field");
    const _component_g_button = _resolveComponent("g-button");
    const _component_g_field_container = _resolveComponent("g-field-container");
    const _component_g_form = _resolveComponent("g-form");
    const _component_g_loader = _resolveComponent("g-loader");
    const _component_g_treeview = _resolveComponent("g-treeview");
    const _component_g_product_record = _resolveComponent("g-product-record");
    const _component_v_horizontal = _resolveComponent("v-horizontal");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$tc('client.Commerce.Products.ItemNumber')) + ":", 1),
                _hoisted_5,
                _createElementVNode("b", null, _toDisplayString(_ctx.currentItem?.itemNumber), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
                _createElementVNode("h4", null, _toDisplayString(_ctx.product?.title), 1)
            ]),
            _hoisted_7
        ]),
        _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_g_image_viewer, {
                        flags: _ctx.product?.flags,
                        images: _ctx.productImages,
                        title: _ctx.currentTitle,
                        "image-spacing": "20px"
                    }, null, 8, ["flags", "images", "title"]),
                    (_ctx.product.hyperlinks && _ctx.product.hyperlinks.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            (_ctx.productImages && _ctx.productImages.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_12))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("div", _hoisted_14, [
                                    _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$tc('client.Commerce.Products.Documents.Title')), 1),
                                    _createElementVNode("div", _hoisted_16, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product.hyperlinks, (hyperlink) => {
                                            return (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                                _createElementVNode("div", _hoisted_18, _toDisplayString(hyperlink.caption), 1),
                                                _createElementVNode("div", null, [
                                                    _createVNode(_component_g_link, {
                                                        src: hyperlink.address,
                                                        target: hyperlink.target
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_ctx.$tc('client.Commerce.Products.Documents.Open')), 1)
                                                        ]),
                                                        _: 2
                                                    }, 1032, ["src", "target"])
                                                ])
                                            ]));
                                        }), 256))
                                    ])
                                ])
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ])
            ]),
            _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$tc('client.Commerce.Products.ItemNumber')) + ":", 1),
                    _hoisted_22,
                    _createElementVNode("b", null, _toDisplayString(_ctx.currentItem?.itemNumber ?? _ctx.product?.itemNumber), 1)
                ]),
                _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("h4", null, _toDisplayString(_ctx.product?.title), 1)
                ]),
                _hoisted_24,
                (_ctx.__texte.length > 0)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.__texte, (text) => {
                            return (_openBlock(), _createElementBlock(_Fragment, null, [
                                _createElementVNode("div", {
                                    class: "product-text mb-4 ms-lg-3 mt-3 mt-lg-0",
                                    innerHTML: text.text
                                }, null, 8, _hoisted_25),
                                (text.seperator)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_28))
                                    : _createCommentVNode("", true)
                            ], 64));
                        }), 256)),
                        _hoisted_29
                    ], 64))
                    : _createCommentVNode("", true),
                (_ctx.currentItem && _ctx.product?.showPrices)
                    ? (_openBlock(), _createBlock(_component_g_product_prices, {
                        key: 1,
                        mode: _ctx.$host.options.get('ecommerce_product_price_top'),
                        product: _ctx.product,
                        "current-item": _ctx.currentItem,
                        options: _ctx.entryData.options,
                        "show-seperator": true
                    }, null, 8, ["mode", "product", "current-item", "options"]))
                    : _createCommentVNode("", true),
                (_ctx.product?.allowOrder || _ctx.product?.allowRequest || _ctx.product?.showPrices)
                    ? (_openBlock(), _createBlock(_component_g_form, {
                        key: 2,
                        ref: "frmOrder"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_g_product_selector, {
                                product: _ctx.product,
                                "entry-data": _ctx.entryData,
                                "item-number": _ctx.currentItemNumber,
                                onCommand: _ctx.OnCommand
                            }, null, 8, ["product", "entry-data", "item-number", "onCommand"]),
                            (_ctx.product.selectionType === 'variante' || _ctx.product.selectionType === 'teaser')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_30, _hoisted_32))
                                : _createCommentVNode("", true),
                            (_ctx.currentItem)
                                ? (_openBlock(), _createBlock(_component_g_product_configurator, {
                                    key: 1,
                                    product: _ctx.product,
                                    "entry-data": _ctx.entryData,
                                    "current-item": _ctx.currentItem
                                }, null, 8, ["product", "entry-data", "current-item"]))
                                : _createCommentVNode("", true),
                            (_ctx.currentItem)
                                ? (_openBlock(), _createBlock(_component_g_product_prices, {
                                    key: 2,
                                    mode: _ctx.$host.options.get('ecommerce_product_price_bottom'),
                                    product: _ctx.product,
                                    "current-item": _ctx.currentItem,
                                    options: _ctx.entryData.options,
                                    "show-seperator": true
                                }, null, 8, ["mode", "product", "current-item", "options"]))
                                : _createCommentVNode("", true),
                            (_ctx.currentItem && (_ctx.product?.allowOrder || _ctx.product?.allowRequest))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                    _createElementVNode("div", _hoisted_34, [
                                        _createVNode(_component_g_quantity_field, {
                                            "input-attr": { class: 'text-center' },
                                            label: _ctx.$t('client.Commerce.Products.Quantity'),
                                            quantity: _ctx.currentItem?.quantityData,
                                            "data-object": _ctx.$data.entryData,
                                            "data-member": "quantity",
                                            "data-mode": "model"
                                        }, null, 8, ["label", "quantity", "data-object"])
                                    ]),
                                    _createElementVNode("div", _hoisted_35, [
                                        (_ctx.product?.allowOrder)
                                            ? (_openBlock(), _createBlock(_component_g_field_container, {
                                                key: 0,
                                                member: "toCart",
                                                label: " ",
                                                showLabel: true
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_g_button, {
                                                        disabled: !_ctx.currentItem?.canOrder,
                                                        text: _ctx.$tc('client.Commerce.Products.AddToCart'),
                                                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.AddItemToCart('S')))
                                                    }, null, 8, ["disabled", "text"])
                                                ]),
                                                _: 1
                                            }))
                                            : _createCommentVNode("", true),
                                        (_ctx.currentItem?.allowRequest)
                                            ? (_openBlock(), _createBlock(_component_g_field_container, {
                                                key: 1,
                                                member: "toRequest",
                                                label: " ",
                                                showLabel: !(_ctx.product?.allowOrder)
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_g_button, {
                                                        disabled: !_ctx.currentItem?.canRequest,
                                                        text: _ctx.$tc('client.Commerce.Products.Request'),
                                                        "button-style": "btn-outline-primary",
                                                        onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.AddItemToCart('A')))
                                                    }, null, 8, ["disabled", "text"])
                                                ]),
                                                _: 1
                                            }, 8, ["showLabel"]))
                                            : _createCommentVNode("", true)
                                    ])
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        _: 1
                    }, 512))
                    : _createCommentVNode("", true)
            ]),
            (_ctx.isLoading)
                ? (_openBlock(), _createBlock(_component_g_loader, { key: 0 }))
                : _createCommentVNode("", true)
        ]),
        ((_ctx.relatedProducts && (_ctx.relatedProducts.length > 0)) || (_ctx.relatedCatageories && (_ctx.relatedCatageories.length > 0)))
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                _hoisted_37,
                (_ctx.relatedCatageories && _ctx.relatedCatageories.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        _createElementVNode("div", null, [
                            _createVNode(_component_g_treeview, {
                                class: "mb-4",
                                "data-source": _ctx.relatedCatageories,
                                "data-structure": "plain"
                            }, null, 8, ["data-source"])
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", {
                    class: _normalizeClass([_ctx.relatedCatageories.length > 0 ? 'col-9' : 'col-12', 'position-relative'])
                }, [
                    _createVNode(_component_v_horizontal, {
                        ref: "accessories",
                        class: "horizontal w-100 h-100",
                        "container-class": "sh-2",
                        button: true
                    }, {
                        default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.relatedProducts, (item) => {
                                return (_openBlock(), _createBlock(_component_g_product_record, { product: item }, null, 8, ["product"]));
                            }), 256))
                        ]),
                        _: 1
                    }, 512)
                ], 2),
                (_ctx.isLoadingRelations)
                    ? (_openBlock(), _createBlock(_component_g_loader, { key: 1 }))
                    : _createCommentVNode("", true)
            ]))
            : _createCommentVNode("", true)
    ]));
}
